(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sba-home-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSlider(root) {
    if (!root || root.dataset.sbaBestReady === 'true') return;
    root.dataset.sbaBestReady = 'true';

    var viewport = root.querySelector('[data-sba-best-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sba-best-card]'));
    var previous = root.querySelector('[data-sba-best-prev]');
    var next = root.querySelector('[data-sba-best-next]');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 3000;
    var timer = null;

    if (!viewport || cards.length < 2) return;

    function stepSize() {
      if (cards.length > 1) return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
      return cards[0].getBoundingClientRect().width;
    }

    function visibleCount() {
      var step = stepSize();
      if (!step) return 1;
      return Math.max(1, Math.floor((viewport.clientWidth + 2) / step));
    }

    function currentIndex() {
      var step = stepSize();
      if (!step) return 0;
      return Math.max(0, Math.min(cards.length - 1, Math.round(viewport.scrollLeft / step)));
    }

    function go(direction) {
      var maxIndex = Math.max(0, cards.length - visibleCount());
      var index = currentIndex();
      if (direction > 0) index = index >= maxIndex ? 0 : index + 1;
      if (direction < 0) index = index <= 0 ? maxIndex : index - 1;
      var target = cards[index];
      if (!target) return;
      viewport.scrollTo({ left: target.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || document.hidden) return;
      timer = window.setInterval(function() { go(1); }, delay);
    }

    if (previous) previous.addEventListener('click', function() { go(-1); start(); });
    if (next) next.addEventListener('click', function() { go(1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function() { if (document.hidden) stop(); else start(); });
    start();
  }

  function initAll(scope) {
    var rootScope = scope || document;
    var sliders = rootScope.querySelectorAll ? rootScope.querySelectorAll('[data-sba-best-slider]') : [];
    Array.prototype.forEach.call(sliders, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sba-home-popular"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initTabs(root) {
    if (!root || root.dataset.sbaTabsReady === 'true') return;
    root.dataset.sbaTabsReady = 'true';
    var tabs = root.querySelectorAll('[data-sba-tab]');
    var panels = root.querySelectorAll('[data-sba-panel]');
    Array.prototype.forEach.call(tabs, function(tab) {
      tab.addEventListener('click', function() {
        var key = tab.getAttribute('data-sba-tab');
        Array.prototype.forEach.call(tabs, function(item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        Array.prototype.forEach.call(panels, function(panel) {
          var active = panel.getAttribute('data-sba-panel') === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function initAll(scope) {
    var rootScope = scope || document;
    var roots = rootScope.querySelectorAll ? rootScope.querySelectorAll('[data-sba-tabs-root]') : [];
    Array.prototype.forEach.call(roots, initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
